
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'

import 'animate.css'

import './lib/amap'
import store from './store'
import VueCookies from 'vue-cookies'
import { Loadmore } from 'mint-ui';

import VueLazyLoad from 'vue-lazyload';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(VueLazyLoad,{
  loading:require('./assets/next.png')
})
Vue.use(ElementUI);

Vue.component(Loadmore.name, Loadmore);

Vue.use(VueCookies)
import './axios'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false;


new Vue({
    el: '#app',
    router,
    $,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js